module.exports = function hasWhitespaces(value) {
  return String(value).includes(" ");
};
